const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// const firebaseConfig = {
//   apiKey: "AIzaSyCRPmJT5swGF4Fo4b_-jTAPNRWwawadKAo",
//   authDomain: "testmedo-7f1f5.firebaseapp.com",
//   projectId: "testmedo-7f1f5",
//   storageBucket: "testmedo-7f1f5.firebasestorage.app",
//   messagingSenderId: "536804577193",
//   appId: "1:536804577193:web:f76bd1bbafbb45f4157eb8",
// };

export default firebaseConfig;
